import MagentoSettings from '@/modules/integrations/types/magento/MagentoSettings'
import MagentoOverview from '@/modules/integrations/types/magento/MagentoOverview'
import MagentoSyncDialog from '@/modules/integrations/types/magento/MagentoSyncDialog'

export default Object.freeze({
  type: 'magento',
  title: 'Integrations_Magento',
  category: 'Integrations_Magento_Category',
  description: 'Integrations_Magento_Description',
  image: require('@/img/integrations/magento.png'),
  requiresAdmin: false,
  components: {
    settings: MagentoSettings,
    overview: MagentoOverview
  },
  actions: [
    {
      icon: 'el-icon-refresh',
      label: 'Integrations_Magento_SyncDialog_Title',
      dialog: MagentoSyncDialog
    }
  ],
  urls: {
    guide: 'https://docs.xtremepush.com/docs/magento-2'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/magento/index.js